<template>
<span>
<p><span style="font-size:10pt">Inhalt der Leistung:</span></p>

<ul>
  <li>
    <p><span style="font-size:10pt">Zeichnerische Darstellung (3D-Modell) der &auml;u&szlig;eren H&uuml;llen des zu sch&uuml;tzenden Objektes<br />
(vereinfacht)</span></p>
  </li>
</ul>

<p><span style="font-size:9pt"><em>Hinweis: Das Modell wird als Grundlage f&uuml;r die Planung der notwendigen Blitzschutzma&szlig;nahmen verwendet.</em></span></p>

</span>
</template>

<script>
export default {
  name: "TooltipZeichnungserstellung"
}
</script>

<style scoped>

</style>
